import React, { useState, useEffect, useRef } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');

    const resizeCanvas = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const particles = [];
    const particleCount = 80;
    const connectionDistance = 150;

    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.5,
        vy: (Math.random() - 0.5) * 0.5,
        radius: Math.random() * 2 + 1,
        color: Math.random() > 0.5 ? '#0047AB' : '#87CEEB'
      });
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Create gradient background
      const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
      gradient.addColorStop(0, 'rgba(0, 71, 171, 0.05)');
      gradient.addColorStop(1, 'rgba(255,255,255,0.05)');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < particles.length; i++) {
        const particle = particles[i];
        particle.x += particle.vx;
        particle.y += particle.vy;

        if (particle.x < 0 || particle.x > canvas.width) particle.vx *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.vy *= -1;

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
        ctx.fillStyle = `${particle.color}${Math.floor(Math.random() * 0.5 + 0.3 * 255).toString(16)}`;
        ctx.fill();

        for (let j = i + 1; j < particles.length; j++) {
          const otherParticle = particles[j];
          const dx = particle.x - otherParticle.x;
          const dy = particle.y - otherParticle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < connectionDistance) {
            const opacity = 1 - distance / connectionDistance;
            ctx.beginPath();
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(otherParticle.x, otherParticle.y);
            ctx.strokeStyle = `rgba(0, 71, 171, ${opacity * 0.15})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }

      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const whatsappMessage = `*RAMA Reflection India Contact Form*\n\n` +
      `*Name:* ${formData.name}\n` +
      `*Email:* ${formData.email}\n` +
      `*Phone:* ${formData.phone}\n` +
      `*Service Interested In:* ${formData.service}\n\n` +
      `*Message:*\n${formData.message}`;

    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappNumber = "918005885520";
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

    // Simulate loading for better UX
    setTimeout(() => {
      window.open(whatsappURL, '_blank');

      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });

      setIsLoading(false);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 4000);
    }, 1000);
  };

  return (
    <>
      <style jsx>{`
        .contact {
          background: linear-gradient(135deg, #f8fbff 0%, #e6f2ff 50%, #d4e6ff 100%);
          color: #333;
          position: relative;
          overflow: hidden;
          padding: 100px 0;
          min-height: 100vh;
        }

        .contact::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120"><rect width="120" height="120" fill="none"/><circle cx="60" cy="60" r="50" stroke="rgba(0,71,171,0.04)" stroke-width="1" fill="none"/><circle cx="60" cy="60" r="30" stroke="rgba(0,71,171,0.02)" stroke-width="0.5" fill="none"/></svg>');
          background-size: 120px 120px;
          z-index: 0;
        }

        .network-canvas {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }

        .container {
          position: relative;
          z-index: 2;
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .contact .section-title {
          color: #0047ab;
          position: relative;
          z-index: 2;
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 15px;
          text-align: center;
          font-family: 'Poppins', sans-serif;
        }

        .contact .section-title::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #0047ab, #00aeff);
          border-radius: 2px;
        }

        .contact .section-subtitle {
          color: #2c5282;
          position: relative;
          z-index: 2;
          font-size: 1.2rem;
          margin-bottom: 50px;
          text-align: center;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
          line-height: 1.6;
        }

        .contact-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          margin-top: 60px;
          position: relative;
          z-index: 2;
          align-items: start;
        }

        .contact-form {
          background: rgba(255, 255, 255, 0.95);
          border-radius: 20px;
          padding: 50px;
          box-shadow: 0 20px 60px rgba(0,71,171,0.08);
          border: 1px solid rgba(0,71,171,0.1);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }

        .contact-form:hover {
          box-shadow: 0 25px 70px rgba(0,71,171,0.12);
        }

        .form-title {
          font-size: 1.8rem;
          font-weight: 600;
          color: #0047ab;
          margin-bottom: 30px;
          text-align: center;
        }

        .form-group {
          margin-bottom: 25px;
        }

        .form-group label {
          display: block;
          margin-bottom: 10px;
          color: #0047ab;
          font-weight: 600;
          font-size: 0.95rem;
        }

        .form-control {
          width: 100%;
          padding: 15px 20px;
          background-color: rgba(255, 255, 255, 0.9);
          border: 2px solid rgba(0, 71, 171, 0.15);
          border-radius: 12px;
          color: #333;
          font-family: 'Poppins', sans-serif;
          font-size: 1rem;
          transition: all 0.3s ease;
        }

        .form-control:focus {
          outline: none;
          border-color: #0047ab;
          box-shadow: 0 0 0 4px rgba(0, 71, 171, 0.1);
          background-color: rgba(255, 255, 255, 1);
          transform: translateY(-2px);
        }

        .form-control::placeholder {
          color: #999;
        }

        .form-control option {
          background-color: #ffffff;
          color: #333;
          padding: 10px;
        }

        textarea.form-control {
          resize: vertical;
          min-height: 140px;
        }

        .btn {
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          color: #fff;
          padding: 16px 32px;
          font-weight: 600;
          border: none;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 15px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          font-size: 1.1rem;
          width: 100%;
          position: relative;
          overflow: hidden;
        }

        .btn:hover {
          background: linear-gradient(135deg, #128C7E 0%, #25D366 100%);
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(37, 211, 102, 0.3);
        }

        .btn:active {
          transform: translateY(-1px);
        }

        .btn:disabled {
          background: #ccc;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        .btn-loading {
          position: relative;
        }

        .btn-loading::after {
          content: '';
          position: absolute;
          width: 20px;
          height: 20px;
          border: 2px solid transparent;
          border-top: 2px solid #fff;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .contact-info {
          display: flex;
          flex-direction: column;
          gap: 25px;
        }

        .info-card {
          background: rgba(255, 255, 255, 0.95);
          border-radius: 20px;
          padding: 35px;
          transition: all 0.3s ease;
          box-shadow: 0 15px 40px rgba(0,71,171,0.08);
          border: 1px solid rgba(0,71,171,0.1);
          backdrop-filter: blur(10px);
        }

        .info-card:hover {
          background: rgba(255, 255, 255, 1);
          transform: translateY(-8px);
          box-shadow: 0 20px 50px rgba(0,71,171,0.15);
        }

        .info-card h3 {
          font-size: 1.4rem;
          margin-bottom: 20px;
          color: #0047ab;
          display: flex;
          align-items: center;
          font-weight: 600;
        }

        .info-card h3 i {
          margin-right: 12px;
          color: #00aeff;
          font-size: 1.2rem;
        }

        .info-card p, .info-card a {
          color: #4a5568;
          line-height: 1.7;
          text-decoration: none;
          margin-bottom: 8px;
          font-size: 1rem;
        }

        .info-card a:hover {
          color: #0047ab;
          text-decoration: underline;
        }

        .success-message {
          background: linear-gradient(135deg, rgba(37, 211, 102, 0.15) 0%, rgba(18, 140, 126, 0.15) 100%);
          color: #128C7E;
          padding: 20px;
          border-radius: 12px;
          margin-top: 25px;
          text-align: center;
          animation: slideIn 0.5s ease;
          position: relative;
          z-index: 2;
          font-weight: 600;
          border: 1px solid rgba(37, 211, 102, 0.2);
        }

        @keyframes slideIn {
          from { 
            opacity: 0; 
            transform: translateY(20px);
          }
          to { 
            opacity: 1; 
            transform: translateY(0);
          }
        }

        .floating-shapes {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
          overflow: hidden;
        }

        .shape {
          position: absolute;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(0,71,171,0.08) 0%, rgba(0,174,255,0.08) 100%);
          animation: float 25s infinite ease-in-out;
        }

        .shape:nth-child(1) {
          width: 400px;
          height: 400px;
          top: -200px;
          right: -150px;
          animation-delay: 0s;
        }

        .shape:nth-child(2) {
          width: 250px;
          height: 250px;
          bottom: -125px;
          left: -75px;
          animation-delay: 8s;
        }

        .shape:nth-child(3) {
          width: 180px;
          height: 180px;
          top: 60%;
          left: -90px;
          animation-delay: 15s;
        }

        @keyframes float {
          0%, 100% { 
            transform: translateY(0) rotate(0deg) scale(1); 
          }
          33% { 
            transform: translateY(-30px) rotate(5deg) scale(1.05); 
          }
          66% { 
            transform: translateY(15px) rotate(-3deg) scale(0.95); 
          }
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .contact {
            padding: 80px 0;
          }
          
          .contact-content {
            gap: 40px;
          }
          
          .contact-form, .info-card {
            padding: 40px;
          }
        }

        @media (max-width: 768px) {
          .contact {
            padding: 60px 0;
          }
          
          .contact .section-title {
            font-size: 2.5rem;
          }
          
          .contact-content {
            grid-template-columns: 1fr;
            gap: 30px;
          }
          
          .contact-form, .info-card {
            padding: 30px;
          }
          
          .container {
            padding: 0 15px;
          }
        }

        @media (max-width: 576px) {
          .contact {
            padding: 40px 0;
          }
          
          .contact .section-title {
            font-size: 2rem;
          }
          
          .contact .section-subtitle {
            font-size: 1.1rem;
          }
          
          .contact-form, .info-card {
            padding: 25px;
            border-radius: 15px;
          }
          
          .form-control {
            padding: 12px 15px;
          }
          
          .btn {
            padding: 14px 24px;
            font-size: 1rem;
          }
          
          .info-card h3 {
            font-size: 1.2rem;
          }
          
          .container {
            padding: 0 10px;
          }
        }

        @media (max-width: 480px) {
          .contact .section-title {
            font-size: 1.8rem;
          }
          
          .contact-form, .info-card {
            padding: 20px;
          }
          
          .shape:nth-child(1) {
            width: 250px;
            height: 250px;
            top: -125px;
            right: -100px;
          }
          
          .shape:nth-child(2) {
            width: 150px;
            height: 150px;
            bottom: -75px;
            left: -50px;
          }
        }
      `}</style>

      <section className="contact section-padding section" id="contact">
        <div className="floating-shapes">
          <div className="shape"></div>
          <div className="shape"></div>
          <div className="shape"></div>
        </div>
        <canvas ref={canvasRef} className="network-canvas"></canvas>
        <div className="container">
          <div className='text-center'>
            <h2 className="section-title">Get In Touch</h2>
            <p className="section-subtitle">
              Ready to switch to solar energy? Contact us today for a free consultation and quote.
            </p>
          </div>
          <div className="row">
            <div className='col-lg-7 col-md-6 col-12 mb-md-0 mb-4'>
              <div className="contact-form p-4">
                <h3 className="form-title">Send us a Message</h3>
                <form onSubmit={handleSubmit} className='row'>
                  <div className="col-lg-6 col-12">
                    <div className="form-group">
                      <label htmlFor="name">Full Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter your full name"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter your email address"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="form-control"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter your phone number"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="service">Service Interested In</label>
                    <select
                      id="service"
                      name="service"
                      className="form-control"
                      value={formData.service}
                      onChange={handleChange}
                    >
                      <option value="">Select a Service</option>
                      <option value="Solar Panels">Solar Panel Installation</option>
                      <option value="Battery Storage">Battery Storage Solutions</option>
                      <option value="Rooftop Solar">Rooftop Solar Systems</option>
                      <option value="Commercial Solar">Commercial Solar Projects</option>
                      <option value="Maintenance">Solar System Maintenance</option>
                      <option value="Consultation">Free Consultation</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea
                      id="message"
                      name="message"
                      className="form-control"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your solar energy requirements..."
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className={`btn ${isLoading ? 'btn-loading' : ''}`}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span>Sending...</span>
                      </>
                    ) : (
                      <>
                        <i className="fab fa-whatsapp"></i>
                        Send via WhatsApp
                      </>
                    )}
                  </button>
                  {showSuccess && (
                    <div className="success-message">
                      <i className="fas fa-check-circle"></i> Message sent successfully! We'll get back to you soon.
                    </div>
                  )}
                </form>
              </div>
            </div>
            <div className='col-lg-5 col-md-6 col-12'>
              <div className="contact-info">
                <div className="info-card">
                  <h3><i className="fas fa-map-marker-alt"></i> Head Office - Jodhpur</h3>
                  <p><strong>Address:</strong></p>
                  <p>203, Blue City Mall, Near Circuit House</p>
                  <p>Jodhpur, Rajasthan, India - 342006</p>
                  <p><strong>Contact:</strong></p>
                  <p><i className="fas fa-phone"></i> <a href="tel:+918005885520">+91 8005885520</a></p>
                  <p><i className="fas fa-phone"></i> <a href="tel:+919660548300">+91 9660548300</a></p>
                  <p><i className="fas fa-envelope"></i> <a href="mailto:sales@rripl.org">sales@rripl.org</a></p>
                </div>

                <div className="info-card">
                  <h3><i className="fas fa-map-marker-alt"></i> Branch Office - Jaipur</h3>
                  <p><strong>Address:</strong></p>
                  <p>456 Renewable Avenue, Jaipur</p>
                  <p>Rajasthan, India - 302001</p>
                  <p><strong>Contact:</strong></p>
                  <p><i className="fas fa-phone"></i> <a href="tel:+917742111481">+91 7742111481</a></p>
                  <p><i className="fas fa-phone"></i> <a href="tel:+919660548300">+91 9660548300</a></p>
                  <p><i className="fas fa-envelope"></i> <a href="mailto:sales@rripl.org">sales@rripl.org</a></p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;